import * as React from 'react';
import { useLocation } from '@reach/router';
import { useStaticQuery, graphql } from 'gatsby';
import defaultSocialThumbnail from '../../../assets/images/social-thumbnail.png';

/* prettier-ignore */
const websiteStructuredData = `{
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Stairs Ireland",
  "alternateName": "Stairs Ireland",
  "url": "https://www.connollystairs.ie"
}`

function WebsiteStructuredData() {
  return <script type="application/ld+json">{websiteStructuredData}</script>;
}

/* prettier-ignore */
const localBusinessStructuredData = `{
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Connolly Stairs & Doors",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Unit 2, Kore Development Park, John F Kennedy Industrial Estate",
    "addressRegion": "Dublin",
    "postalCode": "Dublin 12",
    "addressCountry": "Ireland"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 53.3284854,
    "longitude": -6.3528648
  },
  "url": "https://www.connollystairs.ie",
  "telephone": "+35314507826",
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": "Monday",
      "opens": "07:30",
      "closes": "17:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": "Tuesday",
      "opens": "07:30",
      "closes": "17:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": "Wednesday",
      "opens": "07:30",
      "closes": "17:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": "Thursday",
      "opens": "07:30",
      "closes": "17:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": "Friday",
      "opens": "07:30",
      "closes": "17:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": "Saturday",
      "opens": "00:00",
      "closes": "00:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": "Sunday",
      "opens": "00:00",
      "closes": "00:00"
    }
  ]
}`;

function BusinessStructuredData() {
  return <script type="application/ld+json">{localBusinessStructuredData}</script>;
}

function SEO({ description, title, children, pageSpecificThumbnail }) {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          author
          siteUrl
        }
      }
    }
  `);

  const metaDescription = description || site.siteMetadata.description;
  const defaultTitle = site.siteMetadata?.title;
  const defaultSiteUrl = site.siteMetadata?.siteUrl;
  const thumbnail = pageSpecificThumbnail || defaultSocialThumbnail;
  const image = `${defaultSiteUrl}${thumbnail}`;
  const { pathname } = useLocation();
  const url = `${defaultSiteUrl}${pathname}`;
  const author = 'Connolly Stairs & Doors';

  return (
    <>
      <html lang="en" />
      <title>{title ?? defaultTitle}</title>
      <link rel="canonical" href={url} />
      <meta name="description" content={metaDescription} />
      <meta property="og:locale" content="en_IE" />
      <meta name="og:site_name" content={defaultTitle} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title ?? defaultTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={image} />
      <meta property="og:image:url" content={image} />
      <meta property="og:image:secure_url" content={image} />
      <meta property="og:image:alt" content={defaultTitle} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={defaultTitle} />
      <meta name="twitter:title" content={title ?? defaultTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta property="author" content={author} />
      <WebsiteStructuredData />
      <BusinessStructuredData />
      <script
        type="module"
        src="https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js"
      />
      {children}
    </>
  );
}

export default SEO;
